/* כפתור "התקנה כאפליקציה": באנדרואיד פותח את חלון ההתקנה, באייפון מראה איך מוסיפים למסך הבית */
import { useApp, toast } from '../store/ui.js';
import { installState, promptInstall } from '../lib/install.js';
import { openModal } from '../app/nav.js';
import { Sheet } from './ui.jsx';
import { Icon } from './Icon.jsx';

function IosSheet() {
  return (
    <Sheet title="התקנה באייפון">
      <div className="sub mb12">באייפון מוסיפים את האפליקציה למסך הבית דרך Safari:</div>
      <ol className="steps">
        <li>פותחים את האתר ב-<b>Safari</b> (לא בכרום ולא מתוך וואטסאפ)</li>
        <li>לוחצים על כפתור <b>השיתוף</b>: ריבוע עם חץ למעלה, בתחתית המסך</li>
        <li>גוללים ובוחרים <b>"הוספה למסך הבית"</b></li>
        <li>לוחצים <b>"הוספה"</b>. האייקון יופיע במסך הבית</li>
      </ol>
      <div className="note mt12">מהאייקון האפליקציה נפתחת במסך מלא, בלי שורת הכתובת, וההתחברות נשמרת.</div>
    </Sheet>
  );
}

async function install() {
  const st = installState();
  if (st === 'ios') return openModal(() => <IosSheet />);
  if (st === 'prompt' && (await promptInstall())) toast('✅ האפליקציה הותקנה. אפשר לפתוח אותה מהמסך הראשי');
}

/** שורה בתפריט. לא מוצגת כשהאפליקציה כבר מותקנת או כשהדפדפן לא תומך */
export function InstallNavItem({ onDone }) {
  useApp();
  const st = installState();
  if (st !== 'prompt' && st !== 'ios') return null;
  return <button className="nav-item" onClick={() => { onDone && onDone(); install(); }}><Icon name="download" />התקנה במסך הבית</button>;
}

/** שורה בהגדרות */
export function InstallSetting() {
  useApp();
  const st = installState();
  return (
    <div className="sr">
      <div><div className="slbl">אפליקציה במסך הבית</div>
        <div className="ssub">{st === 'installed' ? 'פתוח עכשיו כאפליקציה ✓' : st === 'none' ? 'בטלפון: פתח את האתר בכרום (אנדרואיד) או Safari (אייפון)' : 'אייקון במסך הבית ופתיחה במסך מלא'}</div></div>
      {(st === 'prompt' || st === 'ios') && <button className="ubtn ubtn-primary ubtn-sm" onClick={install}>התקנה</button>}
    </div>
  );
}
